import * as _ from 'lodash';
import { ICategoryService } from '../../services/';
import { Dispatcher, GetStore, Dispatch } from '../Store';
import * as C from './categories.constants';
import * as Actions from './categories.actions';
import { Category } from '../../models/';

export interface ICategoryActionsService {
    getOne(guid: string): Dispatcher<Category>;
    getAll(): Dispatcher<Category[]>;
    getAll(force: boolean): Dispatcher<Category[]>;
    addOne(targetDashboard: Category): Dispatcher<Category[]>;
    addMany(targetDashboards: Category[]): Dispatcher<Category[]>;
    updateOne(targetDashboard: Category): Dispatcher<Category[]>;
    updateMany(targetDashboards: Category[]): Dispatcher<Category[]>;
    deleteOne(guid: string): Dispatcher<Category[]>;
    deleteMany(guids: string[]): Dispatcher<Category[]>;
}

export class CategoryActionsService implements ICategoryActionsService {
    static serviceId = 'categoryActionsService';
    static $inject = ['$q', 'categoryService'];

    constructor(
        private _$q: angular.IQService,
        private _categoryService: ICategoryService) {
    }

    getOne(guid: string): Dispatcher<Category> {
        return (dispatch: Dispatch<Category>, getState: GetStore) => {
            const { categories } = getState();
            if (!categories.isLoading && !categories.isLoaded) {
                dispatch(Actions.loadCategories() as any);
                return this._categoryService.getAll(true)
                    .then(data => {
                        dispatch(Actions.loadCategoriesSuccess(data) as any);
                        const category = _.find(data, c => c.guid === guid);
                        return category;
                    })
                    .catch(reason => {
                        dispatch({ type: C.CATEGORIES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(categories.dictionary[guid]);
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean): Dispatcher<Category[]> {
        return (dispatch: Dispatch<Category[]>, getState: GetStore) => {
            const { categories } = getState();
            if (force || (!categories.isLoading && !categories.isLoaded)) {
                dispatch(Actions.loadCategories());
                return this._categoryService.getAll(force)
                    .then(data => {
                        dispatch(Actions.loadCategoriesSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: C.CATEGORIES_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Category>(categories.dictionary));
            }
        };
    }

    addOne(category: Category): Dispatcher<Category[]> {
        return this.addMany([category]);
    }

    addMany(targetCategories: Category[]): Dispatcher<Category[]> {
        return (dispatch: Dispatch<Category[]>, getState: GetStore) => {
            const { categories } = getState();
            if (targetCategories && targetCategories.length > 0) {
                dispatch(Actions.addCategories(targetCategories) as any);
                return this._categoryService.addCategories(targetCategories)
                    .then(data => {
                        dispatch(Actions.addCategoriesSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: C.CATEGORIES_ADD_ERROR, payload: reason } as any);
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Category>(categories.dictionary));
            }
        };
    }

    updateOne(category: Category): Dispatcher<Category[]> {
        return this.updateMany([category]);
    }

    updateMany(targetCategories: Category[]): Dispatcher<Category[]> {
        return (dispatch: Dispatch<Category[]>, getState: GetStore) => {
            const { categories } = getState();
            if (targetCategories && targetCategories.length > 0) {
                dispatch(Actions.updateCategories(targetCategories));
                return this._categoryService.updateCategories(targetCategories)
                    .then(data => {
                        const categories = data;
                        dispatch(Actions.updateCategoriesSuccess(categories));
                        return categories;
                    })
                    .catch((reason) => {
                        dispatch({ type: C.CATEGORIES_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Category>(categories.dictionary));
            }
        };
    }

    deleteOne(guid: string): Dispatcher<Category[]> {
        return this.deleteMany([guid]);
    }

    deleteMany(guids: string[]): Dispatcher<Category[]> {
        return (dispatch: Dispatch<Category[]>, getState: GetStore) => {
            const { categories } = getState();
            if (guids && guids.length > 0) {
                dispatch(Actions.deleteCategories(guids) as any);
                return this._categoryService.deleteCategories(guids)
                    .then(data => {
                        const categories = data;
                        dispatch(Actions.deleteCategoriesSuccess(categories));
                        return categories;
                    })
                    .catch((reason) => {
                        dispatch({ type: C.CATEGORIES_DELETE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<Category>(categories.dictionary));
            }
        };
    }
}